const semanticClassNames = {
  root: 'social-player-instagram',
  iFrame: 'social-player-instagram__iframe',
} as const;

export default semanticClassNames;
